// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutWrapper_container__1qOdW"};